"use client"

import React, { createContext, useContext, useState, useEffect } from "react"

type Course = "DSAT" | "IELTS"

interface CourseContextType {
    course: Course
    setCourse: (course: Course) => void
}

const CourseContext = createContext<CourseContextType | undefined>(undefined)

export function CourseProvider({ children }: { children: React.ReactNode }) {
    const [course, setCourse] = useState<Course>("DSAT")

    // Persist course selection in localStorage
    useEffect(() => {
        const savedCourse = localStorage.getItem("selected-course") as Course
        if (savedCourse && (savedCourse === "DSAT" || savedCourse === "IELTS")) {
            setCourse(savedCourse)
        }
    }, [])

    const handleSetCourse = (newCourse: Course) => {
        setCourse(newCourse)
        localStorage.setItem("selected-course", newCourse)
    }

    return (
        <CourseContext.Provider value={{ course, setCourse: handleSetCourse }}>
            {children}
        </CourseContext.Provider>
    )
}

export function useCourse() {
    const context = useContext(CourseContext)
    if (context === undefined) {
        throw new Error("useCourse must be used within a CourseProvider")
    }
    return context
}
